import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./components/home/home";
import Contact from "./components/contact/contact";
import Search from "./components/search/search";
import Help from "./components/help/help";
import SuccessStories from "./components/successstories/successStories";
import Terms from "./components/terms/terms";
import Registration from "./components/registration/registration";
import Login from "./components/login/login";
import Committee from "./components/committee/committee";
import Events from "./components/events/events";
import ProfilesHome from "./components/profiles/profilesHome";
import ProfileDetails from "./components/profiles/profileDetails";
import MyProfile from "./components/profiles/myProfile";
import ProfileCompleteInfo from "./components/profiles/profileCompleteInfo";
import CommitteeContributions from "./components/committeeContribution/committeeContribution";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/home" element={<Home />} />
        <Route index element={<Home />} />
        <Route path="search" element={<Search />} />
        <Route path="contact" element={<Contact />} />
        <Route path="help" element={<Help />} />
        <Route path="successstories" element={<SuccessStories />} />
        <Route path="terms" element={<Terms />} />
        <Route path="register" element={<Registration />} />
        <Route path="login" element={<Login />} />          
        <Route path="committee" element={<Committee />} />
        <Route path="committeeContribution" element={<CommitteeContributions />} />
        <Route path="events" element={<Events />} />
        <Route path="profiles/:type?/:gender?" element={<ProfilesHome />} />
        <Route path="profilesDetails/:id?" element={<ProfileDetails />} />
        <Route path="profileCompleteInfo/:id?" element={<ProfileCompleteInfo />} />
        <Route path="myProfile" element={<MyProfile />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
